<header class="subj-card__head">
  <h3 class="subj-card__title">
    <span class="subj-card__title-icon"
          [style.background]="iconBg"
          [style.color]="iconColor">
      <i [class]="iconClass"></i>
    </span>
    {{ titleKey | translate }}
  </h3>

  @if (viewAllLink) {
    <a class="subj-card__view-all" [routerLink]="viewAllLink">
      {{ viewAllLabelKey | translate }}
      <i class="fa-solid fa-arrow-right"></i>
    </a>
  }
</header>

<div class="subj-card__grid"
     [style.grid-template-columns]="'repeat(' + columns + ', 1fr)'">
  @for (subject of subjects; track $index; let i = $index) {
    <div class="subj"
         [style.--c]="subject.color"
         [style.animation-delay.ms]="i * 60">
      <!-- Icône rendue seulement si l'appelant en fournit une : les matières
           n'en portent pas. -->
      @if (subject.icon) {
        <div class="subj__icon">
          <i [class]="subject.icon"></i>
        </div>
      }
      <div class="subj__name">
        @if (subject.isFavorite) {
          <i class="fa-solid fa-star subj__star"
             [attr.aria-label]="'SUBJECTS.FAVORITE' | translate"></i>
        }
        {{ subject.i18nKey ? (subject.i18nKey | translate) : subject.name }}
      </div>
      <div class="subj__progress">
        <span [style.width.%]="subject.progress"></span>
      </div>
      <div class="subj__pct">{{ subject.progress }}%</div>
    </div>
  }
</div>
